import classes from "./LocalCommitteePagesHeader.module.css";
import AiALogo from "../../Assets/Images/AIESECBlueLogo.svg";
import { capitalize } from "../../HelperFunctions/capitalize";

const LocalCommitteePagesHeader = ({ localCommittee }) => {
  return (
    <>
    <section className={classes.container}>
      <div className={classes.headerAndImage}>
        <div className={classes.imageHeading}>
        <img
          src={ AiALogo}
          alt={localCommittee?.altText || "AIESEC Logo"}
          loading="lazy"
        />
       <span> IN {localCommittee?.title?.toUpperCase()}</span>
        </div>

        
        <h1>
          LC <span>{capitalize(localCommittee?.title)}</span>
        </h1>
      </div>
      <div className={classes.contactSection}>
        <h6>CONTACT</h6>
        <div className={classes.iconsAndTopic}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M20 20H4C2.89543 20 2 19.1046 2 18V5.913C2.04661 4.84255 2.92853 3.99899 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20ZM4 7.868V18H20V7.868L12 13.2L4 7.868ZM4.8 6L12 10.8L19.2 6H4.8Z"
              fill="#787878"
            />
          </svg>
          <span>Email</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z"
              fill="#2E3A59"
            />
          </svg>
        </div>
        <a href={`mailto:${localCommittee?.contact?.email}`}>
          {localCommittee?.contact?.email}
        </a>

        <a href={`https://wa.me/${localCommittee?.contact?.whatsapp}`} rel="noopener noreferrer"
         target="_blank" className={classes.iconsAndTopic}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="26"
            viewBox="0 0 26 26"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M19.9366 6.10245C19.0356 5.19557 17.9637 4.47649 16.7828 3.98686C15.602 3.49723 14.3357 3.24678 13.0574 3.25003C7.69708 3.25003 3.33342 7.61261 3.33125 12.9751C3.33125 14.6889 3.77867 16.3616 4.62908 17.8371L3.25 22.8757L8.40558 21.5226C9.83168 22.2989 11.4294 22.706 13.0531 22.7067H13.0574C18.4167 22.7067 22.7803 18.3441 22.7825 12.9816C22.7862 11.7038 22.5366 10.4379 22.0481 9.25718C21.5596 8.07642 20.8419 7.00418 19.9366 6.10245ZM13.0574 21.0654H13.0542C11.6063 21.0656 10.1851 20.6761 8.93967 19.9377L8.645 19.7622L5.58567 20.5649L6.40142 17.5825L6.20967 17.277C5.40019 15.9883 4.97167 14.497 4.97358 12.9751C4.97575 8.51828 8.60167 4.89236 13.0607 4.89236C14.1226 4.89 15.1745 5.09829 16.1554 5.50515C17.1363 5.91202 18.0267 6.50939 18.7752 7.2627C19.5278 8.01241 20.1242 8.90383 20.5301 9.88545C20.936 10.8671 21.1434 11.9194 21.1402 12.9816C21.138 17.4384 17.5121 21.0654 13.0574 21.0654ZM17.4915 15.0107C17.2477 14.8883 16.0539 14.3011 15.8307 14.2199C15.6087 14.1386 15.4472 14.0985 15.2847 14.3412C15.1222 14.5839 14.6564 15.1309 14.5145 15.2934C14.3726 15.4559 14.2307 15.4754 13.988 15.3541C13.7453 15.2328 12.9621 14.976 12.0337 14.1484C11.3111 13.5038 10.8236 12.7086 10.6817 12.4649C10.5397 12.2211 10.6665 12.09 10.7889 11.9687C10.8983 11.8604 11.0316 11.6849 11.1529 11.5429C11.2742 11.401 11.3143 11.3003 11.3956 11.1378C11.4768 10.9753 11.4367 10.8334 11.375 10.712C11.3143 10.5896 10.8279 9.39361 10.6253 8.9072C10.4292 8.43595 10.2288 8.49878 10.0793 8.49228C9.9245 8.48595 9.76954 8.48306 9.61458 8.48361C9.49136 8.48675 9.37011 8.51532 9.25845 8.56752C9.14678 8.61971 9.04711 8.69442 8.96567 8.78695C8.7425 9.0307 8.11525 9.61786 8.11525 10.8139C8.11525 12.0099 8.98625 13.1658 9.10758 13.3283C9.22892 13.4908 10.8214 15.9445 13.2589 16.9975C13.8396 17.2478 14.2924 17.3973 14.6445 17.5099C15.2262 17.6952 15.756 17.6681 16.1752 17.6064C16.6422 17.537 17.6128 17.0192 17.8154 16.4515C18.018 15.8839 18.018 15.3974 17.9573 15.2956C17.8967 15.1938 17.7331 15.132 17.4915 15.0107Z"
              fill="#787878"
            />
          </svg>
          <span>Whatsapp</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z"
              fill="#2E3A59"
            />
          </svg>
        </a>
      </div>
      <div className={classes.informationSection}>
        <h6>WHY AIESEC IN {localCommittee?.title?.toUpperCase()}</h6>
        <p>
         {localCommittee?.aboutTextOne}
        </p>
        <p>
         {localCommittee?.aboutTextTwo}
        </p>
      </div>
    </section>
    </>
  );
};

export default LocalCommitteePagesHeader;
